import { useEffect, useState } from 'react'

// local imports
import { IRateItems } from 'types/RateType'
import RateService from 'service/RateService'

export default function useGetRateItems() {
  const [items, setItems] = useState<IRateItems[] | []>([])
  const [loading, setLoading] = useState(true)

  /* Get Rate items */
  const getRateItems = () => {
    // setLoading(true)
    RateService.getRateItems()
      .then((r) => setItems(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => getRateItems(), [])

  return { items, getRateItems, loading }
}
